/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BulkAssignHomeFactoryDto,
  BulkAssignHomeFactoryResultDto,
  CreateWorkforceWorkerDto,
  HomeFactoryDto,
  PutHomeFactoryDto,
  UpdateWorkforceWorkerDto,
  WorkerListItemDto,
  WorkerScanLabelsDto,
  WorkersControllerListWorkersParams,
  WorkforceHomeFactoriesControllerListParams,
  WorkforceWorkerDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type workersControllerListWorkersResponse200 = {
  data: WorkerListItemDto[]
  status: 200
}

export type workersControllerListWorkersResponse403 = {
  data: void
  status: 403
}

export type workersControllerListWorkersResponseSuccess = (workersControllerListWorkersResponse200) & {
  headers: Headers;
};
export type workersControllerListWorkersResponseError = (workersControllerListWorkersResponse403) & {
  headers: Headers;
};

export type workersControllerListWorkersResponse = (workersControllerListWorkersResponseSuccess | workersControllerListWorkersResponseError)

export const getWorkersControllerListWorkersUrl = (params: WorkersControllerListWorkersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/workers?${stringifiedParams}` : `/workers`
}

/**
 * Active, unarchived workforce members with the business's own ID number where one is held (ENG-871: the Support Log's Workforce dropdown). Ordered by first name.
 * @summary A partner's active workforce
 */
export const workersControllerListWorkers = async (params: WorkersControllerListWorkersParams, options?: Parameters<typeof customFetch>[1]): Promise<workersControllerListWorkersResponse> => {

  return customFetch<workersControllerListWorkersResponse>(getWorkersControllerListWorkersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkersControllerListWorkersQueryKey = (params?: WorkersControllerListWorkersParams,) => {
    return [
    `/workers`, ...(params ? [params] : [])
    ] as const;
    }


export const getWorkersControllerListWorkersQueryOptions = <TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(params: WorkersControllerListWorkersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkersControllerListWorkersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workersControllerListWorkers>>> = ({ signal }) => workersControllerListWorkers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkersControllerListWorkersQueryResult = NonNullable<Awaited<ReturnType<typeof workersControllerListWorkers>>>
export type WorkersControllerListWorkersQueryError = void


export function useWorkersControllerListWorkers<TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(
 params: WorkersControllerListWorkersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workersControllerListWorkers>>,
          TError,
          Awaited<ReturnType<typeof workersControllerListWorkers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkersControllerListWorkers<TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(
 params: WorkersControllerListWorkersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workersControllerListWorkers>>,
          TError,
          Awaited<ReturnType<typeof workersControllerListWorkers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkersControllerListWorkers<TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(
 params: WorkersControllerListWorkersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A partner's active workforce
 */

export function useWorkersControllerListWorkers<TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(
 params: WorkersControllerListWorkersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkersControllerListWorkersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary A partner's active workforce
 */
export const prefetchWorkersControllerListWorkersQuery = async <TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(
 queryClient: QueryClient, params: WorkersControllerListWorkersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkersControllerListWorkersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getWorkersControllerListWorkersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(params: WorkersControllerListWorkersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkersControllerListWorkersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workersControllerListWorkers>>> = ({ signal }) => workersControllerListWorkers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkersControllerListWorkersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workersControllerListWorkers>>>
export type WorkersControllerListWorkersSuspenseQueryError = void


export function useWorkersControllerListWorkersSuspense<TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(
 params: WorkersControllerListWorkersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkersControllerListWorkersSuspense<TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(
 params: WorkersControllerListWorkersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkersControllerListWorkersSuspense<TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(
 params: WorkersControllerListWorkersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A partner's active workforce
 */

export function useWorkersControllerListWorkersSuspense<TData = Awaited<ReturnType<typeof workersControllerListWorkers>>, TError = void>(
 params: WorkersControllerListWorkersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workersControllerListWorkers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkersControllerListWorkersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workforceControllerListResponse200 = {
  data: WorkforceWorkerDto[]
  status: 200
}

export type workforceControllerListResponse401 = {
  data: void
  status: 401
}

export type workforceControllerListResponse403 = {
  data: void
  status: 403
}

export type workforceControllerListResponse404 = {
  data: void
  status: 404
}

export type workforceControllerListResponseSuccess = (workforceControllerListResponse200) & {
  headers: Headers;
};
export type workforceControllerListResponseError = (workforceControllerListResponse401 | workforceControllerListResponse403 | workforceControllerListResponse404) & {
  headers: Headers;
};

export type workforceControllerListResponse = (workforceControllerListResponseSuccess | workforceControllerListResponseError)

export const getWorkforceControllerListUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/workers`
}

/**
 * @summary List the partner workforce, including archived workers
 */
export const workforceControllerList = async (partnerId: string, options?: Parameters<typeof customFetch>[1]): Promise<workforceControllerListResponse> => {

  return customFetch<workforceControllerListResponse>(getWorkforceControllerListUrl(partnerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkforceControllerListQueryKey = (partnerId: string,) => {
    return [
    `/partners/${partnerId}/workers`
    ] as const;
    }


export const getWorkforceControllerListQueryOptions = <TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkforceControllerListQueryKey(partnerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workforceControllerList>>> = ({ signal }) => workforceControllerList(partnerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkforceControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof workforceControllerList>>>
export type WorkforceControllerListQueryError = void


export function useWorkforceControllerList<TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(
 partnerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workforceControllerList>>,
          TError,
          Awaited<ReturnType<typeof workforceControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceControllerList<TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workforceControllerList>>,
          TError,
          Awaited<ReturnType<typeof workforceControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceControllerList<TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the partner workforce, including archived workers
 */

export function useWorkforceControllerList<TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkforceControllerListQueryOptions(partnerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List the partner workforce, including archived workers
 */
export const prefetchWorkforceControllerListQuery = async <TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(
 queryClient: QueryClient, partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkforceControllerListQueryOptions(partnerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getWorkforceControllerListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkforceControllerListQueryKey(partnerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workforceControllerList>>> = ({ signal }) => workforceControllerList(partnerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkforceControllerListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workforceControllerList>>>
export type WorkforceControllerListSuspenseQueryError = void


export function useWorkforceControllerListSuspense<TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(
 partnerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceControllerListSuspense<TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceControllerListSuspense<TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the partner workforce, including archived workers
 */

export function useWorkforceControllerListSuspense<TData = Awaited<ReturnType<typeof workforceControllerList>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkforceControllerListSuspenseQueryOptions(partnerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workforceControllerCreateResponse201 = {
  data: WorkforceWorkerDto
  status: 201
}

export type workforceControllerCreateResponse401 = {
  data: void
  status: 401
}

export type workforceControllerCreateResponse403 = {
  data: void
  status: 403
}

export type workforceControllerCreateResponse404 = {
  data: void
  status: 404
}

export type workforceControllerCreateResponseSuccess = (workforceControllerCreateResponse201) & {
  headers: Headers;
};
export type workforceControllerCreateResponseError = (workforceControllerCreateResponse401 | workforceControllerCreateResponse403 | workforceControllerCreateResponse404) & {
  headers: Headers;
};

export type workforceControllerCreateResponse = (workforceControllerCreateResponseSuccess | workforceControllerCreateResponseError)

export const getWorkforceControllerCreateUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/workers`
}

/**
 * @summary Create a worker in this partner’s workforce
 */
export const workforceControllerCreate = async (partnerId: string,
    createWorkforceWorkerDto: CreateWorkforceWorkerDto, options?: Parameters<typeof customFetch>[1]): Promise<workforceControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workforceControllerCreateResponse>(getWorkforceControllerCreateUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWorkforceWorkerDto)
  }
);}





export const getWorkforceControllerCreateMutationKey = () => ['workforceControllerCreate'] as const;

export const getWorkforceControllerCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceControllerCreate>>, TError,WorkforceControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workforceControllerCreate>>, TError,WorkforceControllerCreateMutationVariables, TContext> => {

const mutationKey = getWorkforceControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workforceControllerCreate>>, WorkforceControllerCreateMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  workforceControllerCreate(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkforceControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof workforceControllerCreate>>>
    export type WorkforceControllerCreateMutationBody = CreateWorkforceWorkerDto
    export type WorkforceControllerCreateMutationError = void
    export type WorkforceControllerCreateMutationVariables = {partnerId: string;data: CreateWorkforceWorkerDto}

    /**
 * @summary Create a worker in this partner’s workforce
 */
export const useWorkforceControllerCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceControllerCreate>>, TError,WorkforceControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workforceControllerCreate>>,
        TError,
        WorkforceControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getWorkforceControllerCreateMutationOptions(options), queryClient);
    }
    export type workforceControllerScanLabelsResponse201 = {
  data: Blob
  status: 201
}

export type workforceControllerScanLabelsResponse401 = {
  data: void
  status: 401
}

export type workforceControllerScanLabelsResponse403 = {
  data: void
  status: 403
}

export type workforceControllerScanLabelsResponse404 = {
  data: void
  status: 404
}

export type workforceControllerScanLabelsResponseSuccess = (workforceControllerScanLabelsResponse201) & {
  headers: Headers;
};
export type workforceControllerScanLabelsResponseError = (workforceControllerScanLabelsResponse401 | workforceControllerScanLabelsResponse403 | workforceControllerScanLabelsResponse404) & {
  headers: Headers;
};

export type workforceControllerScanLabelsResponse = (workforceControllerScanLabelsResponseSuccess | workforceControllerScanLabelsResponseError)

export const getWorkforceControllerScanLabelsUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/workers/scan-labels`
}

/**
 * One worker per landscape CR80 page (85.60 × 53.98 mm), with zero page margins for card printers. Each QR contains worker:<uuid>. Every selected worker must belong to the partner. Up to 500 cards per request.
 * @summary Print worker QR labels on CR80 cards
 */
export const workforceControllerScanLabels = async (partnerId: string,
    workerScanLabelsDto: WorkerScanLabelsDto, options?: Parameters<typeof customFetch>[1]): Promise<workforceControllerScanLabelsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workforceControllerScanLabelsResponse>(getWorkforceControllerScanLabelsUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workerScanLabelsDto)
  }
);}





export const getWorkforceControllerScanLabelsMutationKey = () => ['workforceControllerScanLabels'] as const;

export const getWorkforceControllerScanLabelsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceControllerScanLabels>>, TError,WorkforceControllerScanLabelsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workforceControllerScanLabels>>, TError,WorkforceControllerScanLabelsMutationVariables, TContext> => {

const mutationKey = getWorkforceControllerScanLabelsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workforceControllerScanLabels>>, WorkforceControllerScanLabelsMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  workforceControllerScanLabels(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkforceControllerScanLabelsMutationResult = NonNullable<Awaited<ReturnType<typeof workforceControllerScanLabels>>>
    export type WorkforceControllerScanLabelsMutationBody = WorkerScanLabelsDto
    export type WorkforceControllerScanLabelsMutationError = void
    export type WorkforceControllerScanLabelsMutationVariables = {partnerId: string;data: WorkerScanLabelsDto}

    /**
 * @summary Print worker QR labels on CR80 cards
 */
export const useWorkforceControllerScanLabels = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceControllerScanLabels>>, TError,WorkforceControllerScanLabelsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workforceControllerScanLabels>>,
        TError,
        WorkforceControllerScanLabelsMutationVariables,
        TContext
      > => {
      return useMutation(getWorkforceControllerScanLabelsMutationOptions(options), queryClient);
    }
    export type workforceControllerGetResponse200 = {
  data: WorkforceWorkerDto
  status: 200
}

export type workforceControllerGetResponse401 = {
  data: void
  status: 401
}

export type workforceControllerGetResponse403 = {
  data: void
  status: 403
}

export type workforceControllerGetResponse404 = {
  data: void
  status: 404
}

export type workforceControllerGetResponseSuccess = (workforceControllerGetResponse200) & {
  headers: Headers;
};
export type workforceControllerGetResponseError = (workforceControllerGetResponse401 | workforceControllerGetResponse403 | workforceControllerGetResponse404) & {
  headers: Headers;
};

export type workforceControllerGetResponse = (workforceControllerGetResponseSuccess | workforceControllerGetResponseError)

export const getWorkforceControllerGetUrl = (partnerId: string,
    workerId: string,) => {




  return `/partners/${partnerId}/workers/${workerId}`
}

/**
 * @summary Get a worker in this partner’s workforce
 */
export const workforceControllerGet = async (partnerId: string,
    workerId: string, options?: Parameters<typeof customFetch>[1]): Promise<workforceControllerGetResponse> => {

  return customFetch<workforceControllerGetResponse>(getWorkforceControllerGetUrl(partnerId,workerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkforceControllerGetQueryKey = (partnerId: string,
    workerId: string,) => {
    return [
    `/partners/${partnerId}/workers/${workerId}`
    ] as const;
    }


export const getWorkforceControllerGetQueryOptions = <TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(partnerId: string,
    workerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkforceControllerGetQueryKey(partnerId,workerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workforceControllerGet>>> = ({ signal }) => workforceControllerGet(partnerId,workerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined && workerId !== null && workerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkforceControllerGetQueryResult = NonNullable<Awaited<ReturnType<typeof workforceControllerGet>>>
export type WorkforceControllerGetQueryError = void


export function useWorkforceControllerGet<TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(
 partnerId: string,
    workerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workforceControllerGet>>,
          TError,
          Awaited<ReturnType<typeof workforceControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceControllerGet<TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(
 partnerId: string,
    workerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workforceControllerGet>>,
          TError,
          Awaited<ReturnType<typeof workforceControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceControllerGet<TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(
 partnerId: string,
    workerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a worker in this partner’s workforce
 */

export function useWorkforceControllerGet<TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(
 partnerId: string,
    workerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkforceControllerGetQueryOptions(partnerId,workerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a worker in this partner’s workforce
 */
export const prefetchWorkforceControllerGetQuery = async <TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    workerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkforceControllerGetQueryOptions(partnerId,workerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getWorkforceControllerGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(partnerId: string,
    workerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkforceControllerGetQueryKey(partnerId,workerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workforceControllerGet>>> = ({ signal }) => workforceControllerGet(partnerId,workerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkforceControllerGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workforceControllerGet>>>
export type WorkforceControllerGetSuspenseQueryError = void


export function useWorkforceControllerGetSuspense<TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(
 partnerId: string,
    workerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceControllerGetSuspense<TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(
 partnerId: string,
    workerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceControllerGetSuspense<TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(
 partnerId: string,
    workerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a worker in this partner’s workforce
 */

export function useWorkforceControllerGetSuspense<TData = Awaited<ReturnType<typeof workforceControllerGet>>, TError = void>(
 partnerId: string,
    workerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkforceControllerGetSuspenseQueryOptions(partnerId,workerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workforceControllerUpdateResponse200 = {
  data: WorkforceWorkerDto
  status: 200
}

export type workforceControllerUpdateResponse401 = {
  data: void
  status: 401
}

export type workforceControllerUpdateResponse403 = {
  data: void
  status: 403
}

export type workforceControllerUpdateResponse404 = {
  data: void
  status: 404
}

export type workforceControllerUpdateResponseSuccess = (workforceControllerUpdateResponse200) & {
  headers: Headers;
};
export type workforceControllerUpdateResponseError = (workforceControllerUpdateResponse401 | workforceControllerUpdateResponse403 | workforceControllerUpdateResponse404) & {
  headers: Headers;
};

export type workforceControllerUpdateResponse = (workforceControllerUpdateResponseSuccess | workforceControllerUpdateResponseError)

export const getWorkforceControllerUpdateUrl = (partnerId: string,
    workerId: string,) => {




  return `/partners/${partnerId}/workers/${workerId}`
}

/**
 * @summary Edit, archive or restore a workforce member
 */
export const workforceControllerUpdate = async (partnerId: string,
    workerId: string,
    updateWorkforceWorkerDto: UpdateWorkforceWorkerDto, options?: Parameters<typeof customFetch>[1]): Promise<workforceControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workforceControllerUpdateResponse>(getWorkforceControllerUpdateUrl(partnerId,workerId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWorkforceWorkerDto)
  }
);}





export const getWorkforceControllerUpdateMutationKey = () => ['workforceControllerUpdate'] as const;

export const getWorkforceControllerUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceControllerUpdate>>, TError,WorkforceControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workforceControllerUpdate>>, TError,WorkforceControllerUpdateMutationVariables, TContext> => {

const mutationKey = getWorkforceControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workforceControllerUpdate>>, WorkforceControllerUpdateMutationVariables> = (props) => {
          const {partnerId,workerId,data} = props ?? {};

          return  workforceControllerUpdate(partnerId,workerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkforceControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof workforceControllerUpdate>>>
    export type WorkforceControllerUpdateMutationBody = UpdateWorkforceWorkerDto
    export type WorkforceControllerUpdateMutationError = void
    export type WorkforceControllerUpdateMutationVariables = {partnerId: string;workerId: string;data: UpdateWorkforceWorkerDto}

    /**
 * @summary Edit, archive or restore a workforce member
 */
export const useWorkforceControllerUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceControllerUpdate>>, TError,WorkforceControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workforceControllerUpdate>>,
        TError,
        WorkforceControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getWorkforceControllerUpdateMutationOptions(options), queryClient);
    }
    export type workforceHomeFactoriesControllerListResponse200 = {
  data: HomeFactoryDto[]
  status: 200
}

export type workforceHomeFactoriesControllerListResponseSuccess = (workforceHomeFactoriesControllerListResponse200) & {
  headers: Headers;
};
;

export type workforceHomeFactoriesControllerListResponse = (workforceHomeFactoriesControllerListResponseSuccess)

export const getWorkforceHomeFactoriesControllerListUrl = (partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/workforce-home-factories?${stringifiedParams}` : `/partners/${partnerId}/workforce-home-factories`
}

/**
 * @summary Effective-dated Workforce home factory assignments
 */
export const workforceHomeFactoriesControllerList = async (partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: Parameters<typeof customFetch>[1]): Promise<workforceHomeFactoriesControllerListResponse> => {

  return customFetch<workforceHomeFactoriesControllerListResponse>(getWorkforceHomeFactoriesControllerListUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkforceHomeFactoriesControllerListQueryKey = (partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams,) => {
    return [
    `/partners/${partnerId}/workforce-home-factories`, ...(params ? [params] : [])
    ] as const;
    }


export const getWorkforceHomeFactoriesControllerListQueryOptions = <TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkforceHomeFactoriesControllerListQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>> = ({ signal }) => workforceHomeFactoriesControllerList(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkforceHomeFactoriesControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>>
export type WorkforceHomeFactoriesControllerListQueryError = unknown


export function useWorkforceHomeFactoriesControllerList<TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(
 partnerId: string,
    params: undefined |  WorkforceHomeFactoriesControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>,
          TError,
          Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceHomeFactoriesControllerList<TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(
 partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>,
          TError,
          Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceHomeFactoriesControllerList<TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(
 partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Effective-dated Workforce home factory assignments
 */

export function useWorkforceHomeFactoriesControllerList<TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(
 partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkforceHomeFactoriesControllerListQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Effective-dated Workforce home factory assignments
 */
export const prefetchWorkforceHomeFactoriesControllerListQuery = async <TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(
 queryClient: QueryClient, partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getWorkforceHomeFactoriesControllerListQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getWorkforceHomeFactoriesControllerListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkforceHomeFactoriesControllerListQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>> = ({ signal }) => workforceHomeFactoriesControllerList(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkforceHomeFactoriesControllerListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>>
export type WorkforceHomeFactoriesControllerListSuspenseQueryError = unknown


export function useWorkforceHomeFactoriesControllerListSuspense<TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(
 partnerId: string,
    params: undefined |  WorkforceHomeFactoriesControllerListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceHomeFactoriesControllerListSuspense<TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(
 partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkforceHomeFactoriesControllerListSuspense<TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(
 partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Effective-dated Workforce home factory assignments
 */

export function useWorkforceHomeFactoriesControllerListSuspense<TData = Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError = unknown>(
 partnerId: string,
    params?: WorkforceHomeFactoriesControllerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkforceHomeFactoriesControllerListSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type workforceHomeFactoriesControllerBulkAssignResponse201 = {
  data: BulkAssignHomeFactoryResultDto
  status: 201
}

export type workforceHomeFactoriesControllerBulkAssignResponse400 = {
  data: void
  status: 400
}

export type workforceHomeFactoriesControllerBulkAssignResponse422 = {
  data: void
  status: 422
}

export type workforceHomeFactoriesControllerBulkAssignResponseSuccess = (workforceHomeFactoriesControllerBulkAssignResponse201) & {
  headers: Headers;
};
export type workforceHomeFactoriesControllerBulkAssignResponseError = (workforceHomeFactoriesControllerBulkAssignResponse400 | workforceHomeFactoriesControllerBulkAssignResponse422) & {
  headers: Headers;
};

export type workforceHomeFactoriesControllerBulkAssignResponse = (workforceHomeFactoriesControllerBulkAssignResponseSuccess | workforceHomeFactoriesControllerBulkAssignResponseError)

export const getWorkforceHomeFactoriesControllerBulkAssignUrl = (partnerId: string,) => {




  return `/partners/${partnerId}/workforce-home-factories/bulk`
}

/**
 * @summary Assign one home factory to many workers from one Effective-from date, in one request
 */
export const workforceHomeFactoriesControllerBulkAssign = async (partnerId: string,
    bulkAssignHomeFactoryDto: BulkAssignHomeFactoryDto, options?: Parameters<typeof customFetch>[1]): Promise<workforceHomeFactoriesControllerBulkAssignResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workforceHomeFactoriesControllerBulkAssignResponse>(getWorkforceHomeFactoriesControllerBulkAssignUrl(partnerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkAssignHomeFactoryDto)
  }
);}





export const getWorkforceHomeFactoriesControllerBulkAssignMutationKey = () => ['workforceHomeFactoriesControllerBulkAssign'] as const;

export const getWorkforceHomeFactoriesControllerBulkAssignMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerBulkAssign>>, TError,WorkforceHomeFactoriesControllerBulkAssignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerBulkAssign>>, TError,WorkforceHomeFactoriesControllerBulkAssignMutationVariables, TContext> => {

const mutationKey = getWorkforceHomeFactoriesControllerBulkAssignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workforceHomeFactoriesControllerBulkAssign>>, WorkforceHomeFactoriesControllerBulkAssignMutationVariables> = (props) => {
          const {partnerId,data} = props ?? {};

          return  workforceHomeFactoriesControllerBulkAssign(partnerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkforceHomeFactoriesControllerBulkAssignMutationResult = NonNullable<Awaited<ReturnType<typeof workforceHomeFactoriesControllerBulkAssign>>>
    export type WorkforceHomeFactoriesControllerBulkAssignMutationBody = BulkAssignHomeFactoryDto
    export type WorkforceHomeFactoriesControllerBulkAssignMutationError = void
    export type WorkforceHomeFactoriesControllerBulkAssignMutationVariables = {partnerId: string;data: BulkAssignHomeFactoryDto}

    /**
 * @summary Assign one home factory to many workers from one Effective-from date, in one request
 */
export const useWorkforceHomeFactoriesControllerBulkAssign = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerBulkAssign>>, TError,WorkforceHomeFactoriesControllerBulkAssignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workforceHomeFactoriesControllerBulkAssign>>,
        TError,
        WorkforceHomeFactoriesControllerBulkAssignMutationVariables,
        TContext
      > => {
      return useMutation(getWorkforceHomeFactoriesControllerBulkAssignMutationOptions(options), queryClient);
    }
    export type workforceHomeFactoriesControllerPutResponse200 = {
  data: HomeFactoryDto[]
  status: 200
}

export type workforceHomeFactoriesControllerPutResponse409 = {
  data: void
  status: 409
}

export type workforceHomeFactoriesControllerPutResponseSuccess = (workforceHomeFactoriesControllerPutResponse200) & {
  headers: Headers;
};
export type workforceHomeFactoriesControllerPutResponseError = (workforceHomeFactoriesControllerPutResponse409) & {
  headers: Headers;
};

export type workforceHomeFactoriesControllerPutResponse = (workforceHomeFactoriesControllerPutResponseSuccess | workforceHomeFactoriesControllerPutResponseError)

export const getWorkforceHomeFactoriesControllerPutUrl = (partnerId: string,
    workerId: string,) => {




  return `/partners/${partnerId}/workforce-home-factories/${workerId}`
}

/**
 * @summary Assign a Workforce home factory from an effective date, preserving history
 */
export const workforceHomeFactoriesControllerPut = async (partnerId: string,
    workerId: string,
    putHomeFactoryDto: PutHomeFactoryDto, options?: Parameters<typeof customFetch>[1]): Promise<workforceHomeFactoriesControllerPutResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<workforceHomeFactoriesControllerPutResponse>(getWorkforceHomeFactoriesControllerPutUrl(partnerId,workerId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putHomeFactoryDto)
  }
);}





export const getWorkforceHomeFactoriesControllerPutMutationKey = () => ['workforceHomeFactoriesControllerPut'] as const;

export const getWorkforceHomeFactoriesControllerPutMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerPut>>, TError,WorkforceHomeFactoriesControllerPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerPut>>, TError,WorkforceHomeFactoriesControllerPutMutationVariables, TContext> => {

const mutationKey = getWorkforceHomeFactoriesControllerPutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workforceHomeFactoriesControllerPut>>, WorkforceHomeFactoriesControllerPutMutationVariables> = (props) => {
          const {partnerId,workerId,data} = props ?? {};

          return  workforceHomeFactoriesControllerPut(partnerId,workerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkforceHomeFactoriesControllerPutMutationResult = NonNullable<Awaited<ReturnType<typeof workforceHomeFactoriesControllerPut>>>
    export type WorkforceHomeFactoriesControllerPutMutationBody = PutHomeFactoryDto
    export type WorkforceHomeFactoriesControllerPutMutationError = void
    export type WorkforceHomeFactoriesControllerPutMutationVariables = {partnerId: string;workerId: string;data: PutHomeFactoryDto}

    /**
 * @summary Assign a Workforce home factory from an effective date, preserving history
 */
export const useWorkforceHomeFactoriesControllerPut = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workforceHomeFactoriesControllerPut>>, TError,WorkforceHomeFactoriesControllerPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workforceHomeFactoriesControllerPut>>,
        TError,
        WorkforceHomeFactoriesControllerPutMutationVariables,
        TContext
      > => {
      return useMutation(getWorkforceHomeFactoriesControllerPutMutationOptions(options), queryClient);
    }
